import { render, staticRenderFns } from "./sn-no-data.vue?vue&type=template&id=91a91570"
import script from "./sn-no-data.vue?vue&type=script&lang=js"
export * from "./sn-no-data.vue?vue&type=script&lang=js"
import style0 from "./sn-no-data.vue?vue&type=style&index=0&id=91a91570&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports